import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { FC } from "react";
import { AttachmentThumbnail } from "../attachment-thumbnail";
import { DATESTRING_FORMAT } from "~served/utils";
import { $dayjs } from "~/libs/dayjs";
import { GetCurrentCompanyResults } from "~/queries/useGetCurrentCompany";
import { PAYMENT_VERIFICATION_UPLOAD_STAGE } from "~served/configs";
import { FormBoarderRow } from "../form-border-row";
import { GetFileByIdResults } from "~/queries/useGetFileById";
export interface PaymentVerificationProps {
  company?: GetCurrentCompanyResults;
  paymentVerification: NonNullable<GetFileByIdResults["_paymentVerifications"]>[number];
}
export const PaymentVerificationList: FC<PaymentVerificationProps> = ({
  company,
  paymentVerification
}) => {
  return <Grid container spacing={2} data-sentry-element="Grid" data-sentry-component="PaymentVerificationList" data-sentry-source-file="payment-verification-list.tsx">
			<Grid xs={12} data-sentry-element="Grid" data-sentry-source-file="payment-verification-list.tsx">
				<FormBoarderRow key={1} label={`Payment # ${paymentVerification.reference.number}`} data-sentry-element="FormBoarderRow" data-sentry-source-file="payment-verification-list.tsx">
					<Grid container spacing={2} data-sentry-element="Grid" data-sentry-source-file="payment-verification-list.tsx">
						<Grid item xs={4} md={2} data-sentry-element="Grid" data-sentry-source-file="payment-verification-list.tsx">
							<TextField label="Uploaded" fullWidth disabled variant="outlined" value={$dayjs(paymentVerification.createdAt).format(DATESTRING_FORMAT)} data-sentry-element="TextField" data-sentry-source-file="payment-verification-list.tsx" />
						</Grid>
						<Grid item xs={4} md={company?.isMultiCurrencyEnabled ? 2 : 3} data-sentry-element="Grid" data-sentry-source-file="payment-verification-list.tsx">
							<TextField label="Received Amount" type="number" fullWidth variant="outlined" disabled value={paymentVerification.receivedAmount} data-sentry-element="TextField" data-sentry-source-file="payment-verification-list.tsx" />
						</Grid>
						{company?.isMultiCurrencyEnabled && <Grid item xs={4} md={2}>
								<TextField label="Received Currency" fullWidth disabled variant="outlined" value={paymentVerification.currency} />
							</Grid>}
						<Grid item xs={6} md={company?.isMultiCurrencyEnabled ? 2 : 3} data-sentry-element="Grid" data-sentry-source-file="payment-verification-list.tsx">
							<TextField label="Received Date" fullWidth variant="outlined" disabled value={$dayjs(paymentVerification.receivedDate).format(DATESTRING_FORMAT)} data-sentry-element="TextField" data-sentry-source-file="payment-verification-list.tsx" />
						</Grid>
						<Grid item xs={6} md={2} data-sentry-element="Grid" data-sentry-source-file="payment-verification-list.tsx">
							<FormControl fullWidth data-sentry-element="FormControl" data-sentry-source-file="payment-verification-list.tsx">
								<InputLabel id="payment-stage-label" data-sentry-element="InputLabel" data-sentry-source-file="payment-verification-list.tsx">Payment Stage</InputLabel>
								<Select labelId="payment-stage-label" id="payment-stage-select" value={paymentVerification.paymentStage} label="Payment Stage" disabled data-sentry-element="Select" data-sentry-source-file="payment-verification-list.tsx">
									<MenuItem key={PAYMENT_VERIFICATION_UPLOAD_STAGE.DEPOSIT_PAYMENT} value={PAYMENT_VERIFICATION_UPLOAD_STAGE.DEPOSIT_PAYMENT} data-sentry-element="MenuItem" data-sentry-source-file="payment-verification-list.tsx">
										Deposit Payment
									</MenuItem>
									<MenuItem key={PAYMENT_VERIFICATION_UPLOAD_STAGE.PARTIAL_PAYMENT} value={PAYMENT_VERIFICATION_UPLOAD_STAGE.PARTIAL_PAYMENT} data-sentry-element="MenuItem" data-sentry-source-file="payment-verification-list.tsx">
										Partial Payment
									</MenuItem>
									<MenuItem key={PAYMENT_VERIFICATION_UPLOAD_STAGE.FINAL_PAYMENT} value={PAYMENT_VERIFICATION_UPLOAD_STAGE.FINAL_PAYMENT} data-sentry-element="MenuItem" data-sentry-source-file="payment-verification-list.tsx">
										Final Payment
									</MenuItem>
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} md={2} data-sentry-element="Grid" data-sentry-source-file="payment-verification-list.tsx">
							<AttachmentThumbnail a={paymentVerification.attachment} data-sentry-element="AttachmentThumbnail" data-sentry-source-file="payment-verification-list.tsx" />
						</Grid>
					</Grid>
				</FormBoarderRow>
			</Grid>
		</Grid>;
};